import DOMPurify from 'dompurify'

export interface UrlSanitizeOptions {
  allowedDomains?: string[]
}

export function isSafeUrl(url: string, options: UrlSanitizeOptions = {}): boolean {
  // Use DOMPurify to check if URL survives sanitization
  const testHtml = `<a href="${url}">test</a>`
  const sanitized = DOMPurify.sanitize(testHtml)
  
  // If href was stripped, URL is unsafe (e.g., javascript:)
  if (!sanitized.includes('href=')) {
    return false
  }

  // Optional domain whitelist
  if (options.allowedDomains?.length) {
    try {
      const parsed = new URL(url, window.location.origin)
      const hostname = parsed.hostname.toLowerCase()
      return options.allowedDomains.some(domain => {
        const d = domain.toLowerCase()
        return hostname === d || hostname.endsWith('.' + d)
      })
    } catch {
      return false
    }
  }

  return true
}
